'use es6';

import keyMirror from 'react-utils/keyMirror';
/**
 * @typedef {Object} FindReplaceMode
 * @property {String} FIND
 * @property {String} REPLACE
 * @property {String} JUMP_TO_LINE
 */

/**
 * Enum of position.
 *
 * @enum {String}
 * @readonly
 */

export default Object.freeze(keyMirror({
  FIND: null,
  REPLACE: null,
  JUMP_TO_LINE: null
}));